module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "流程名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "pos-rel",
    attrs: {
      "label": "流程图标",
      "prop": "icon"
    }
  }, [_c('selectIcon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    on: {
      "selectOneIcon": _vm.getSelectedIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-30 h-30 pointer",
    class: _vm.iconSelected,
    on: {
      "click": _vm.openIcon
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.icon),
      expression: "form.icon",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "hide",
    domProps: {
      "value": (_vm.form.icon)
    },
    on: {
      "input": function($event) {
        _vm.form.icon = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否常用"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_used),
      expression: "form.is_used"
    }],
    staticClass: "radio",
    attrs: {
      "label": 0
    },
    domProps: {
      "value": (_vm.form.is_used)
    },
    on: {
      "input": function($event) {
        _vm.form.is_used = $event
      }
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_used),
      expression: "form.is_used"
    }],
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    domProps: {
      "value": (_vm.form.is_used)
    },
    on: {
      "input": function($event) {
        _vm.form.is_used = $event
      }
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编号前缀",
      "prop": "num_prefix"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.num_prefix),
      expression: "form.num_prefix",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.num_prefix)
    },
    on: {
      "input": function($event) {
        _vm.form.num_prefix = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据管理用户组",
      "prop": "manage_group"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.manage_group),
      expression: "form.manage_group"
    }],
    staticClass: "w-200",
    attrs: {
      "multiple": "",
      "placeholder": "请选择数据管理用户组"
    },
    domProps: {
      "value": (_vm.form.manage_group)
    },
    on: {
      "input": function($event) {
        _vm.form.manage_group = $event
      }
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.else,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "流程分类",
      "prop": "type_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type_id),
      expression: "form.type_id"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请选择流程分类",
      "clearable": ""
    },
    domProps: {
      "value": (_vm.form.type_id)
    },
    on: {
      "input": function($event) {
        _vm.form.type_id = $event
      }
    }
  }, _vm._l((_vm.typeOption), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "流程描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.description),
      expression: "form.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      }
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        _vm.form.description = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联表单",
      "prop": "model_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.model_id),
      expression: "form.model_id"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请选择关联表单"
    },
    domProps: {
      "value": (_vm.form.model_id)
    },
    on: {
      "input": function($event) {
        _vm.form.model_id = $event
      }
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title + '(' + item.name + ')',
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许发起人",
      "prop": "allow_uid"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.allow_uid),
      expression: "form.allow_uid"
    }],
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.allow_uid)
    },
    on: {
      "input": function($event) {
        _vm.form.allow_uid = $event
      }
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许发起部门",
      "prop": "allow_struct"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.allow_struct),
      expression: "form.allow_struct"
    }],
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.allow_struct)
    },
    on: {
      "input": function($event) {
        _vm.form.allow_struct = $event
      }
    }
  }, _vm._l((_vm.structs), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许发起用户组",
      "prop": "allow_group"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.allow_group),
      expression: "form.allow_group"
    }],
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.allow_group)
    },
    on: {
      "input": function($event) {
        _vm.form.allow_group = $event
      }
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实例命名方式",
      "prop": "case_config"
    }
  }, [_c('div', _vm._l((_vm.form.case_config), function(item, index) {
    return _c('span', [(index != 0) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(_vm._s(_vm.filterCaseName(item)) + "\n        ")])
  })), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.case_config),
      expression: "form.case_config"
    }],
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.case_config)
    },
    on: {
      "input": function($event) {
        _vm.form.case_config = $event
      }
    }
  }, _vm._l((_vm.caseOption), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3287effc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/add.vue
// module id = 1814
// module chunks = 2